import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "title ml-2" }
const _hoisted_2 = { class: "title ml-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_FreeTag = _resolveComponent("FreeTag")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_ProfileManagement = _resolveComponent("ProfileManagement")!

  return (_openBlock(), _createElementBlock("div", null, [
    (
                _ctx.companyUser &&
                _ctx.isAccountActive &&
                (_ctx.company.id !== _ctx.currentUser.company.id || !_ctx.isBobbeeBusiness)
            )
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 0,
          "no-gutters": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              class: "pb-1"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.roleTitle), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!_ctx.companyUser)
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 1,
          "no-gutters": "",
          class: "mt-2"
        }, {
          default: _withCtx(() => [
            (_ctx.loadingCompanyUser)
              ? (_openBlock(), _createBlock(_component_v_overlay, {
                  key: 0,
                  absolute: true,
                  "model-value": _ctx.loadingCompanyUser
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_progress_circular, {
                      indeterminate: "",
                      size: "64"
                    })
                  ]),
                  _: 1
                }, 8, ["model-value"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.companyUser && _ctx.isAccountActive)
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 2,
          "no-gutters": "",
          class: "mt-2"
        }, {
          default: _withCtx(() => [
            (!_ctx.isLegalPerson && !_ctx.isBobbeeBusiness)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 0,
                  cols: "6",
                  class: "pl-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select_filled, {
                      outlined: "",
                      items: _ctx.availableRoles,
                      modelValue: _ctx.companyUser.role,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.companyUser.role) = $event)),
                      label: "Rôle",
                      disabled: _ctx.currentUserIsAccountingEmployee || !_ctx.hasAccessToCompany,
                      "hide-details": "",
                      density: "compact",
                      "item-title": "text"
                    }, null, 8, ["items", "modelValue", "disabled"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!_ctx.isLegalPerson && _ctx.company.id !== _ctx.user.company.id)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 1,
                  cols: "6",
                  class: "pl-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select_filled, {
                      outlined: "",
                      items: _ctx.availableProfiles,
                      modelValue: _ctx.companyUser.profile.id,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.companyUser.profile.id) = $event)),
                      "item-title": _ctx.getProfileName,
                      "item-value": "id",
                      label: "Profil",
                      "hide-details": "",
                      density: "compact"
                    }, null, 8, ["items", "modelValue", "item-title"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.companyUser && _ctx.isAccountActive)
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 3,
          "no-gutters": "",
          class: "mt-2"
        }, {
          default: _withCtx(() => [
            (!_ctx.isLegalPerson && _ctx.accessRightPartition)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 0,
                  cols: "2",
                  class: "pl-2"
                }, {
                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                    _createTextVNode(" Droits d'accès ")
                  ])),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!_ctx.isLegalPerson && _ctx.accessRightPartition)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 1,
                  cols: "10",
                  class: "pl-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_FreeTag, {
                      company: _ctx.company,
                      companyTags: _ctx.accessRightTags,
                      onlyOneByPartition: false,
                      partitionTagId: _ctx.accessRightPartition.id,
                      createIfMissing: true,
                      companyUser: _ctx.companyUser,
                      onOnTagsChanged: _ctx.onTagsChanged
                    }, null, 8, ["company", "companyTags", "partitionTagId", "companyUser", "onOnTagsChanged"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.companyUser && _ctx.isAccountActive)
      ? (_openBlock(), _createBlock(_component_v_divider, {
          key: 4,
          class: "my-2"
        }))
      : _createCommentVNode("", true),
    (_ctx.companyUser)
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 5,
          "no-gutters": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              class: "pb-1"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.legalRepresentativeTitle), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.companyUser && _ctx.isAccountActive)
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 6,
          "no-gutters": "",
          class: "mt-2"
        }, {
          default: _withCtx(() => [
            (!_ctx.isLegalPerson)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 0,
                  cols: "4",
                  class: "pl-2"
                }, {
                  default: _withCtx(() => [
                    (_ctx.user.company.id !== _ctx.company.id)
                      ? (_openBlock(), _createBlock(_component_v_switch, {
                          key: 0,
                          modelValue: _ctx.companyUser.partOfCompany,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.companyUser.partOfCompany) = $event)),
                          "hide-details": "",
                          class: "my-0",
                          label: "Fait partie de la société",
                          ripple: false
                        }, null, 8, ["modelValue"]))
                      : (_openBlock(), _createBlock(_component_v_switch, {
                          key: 1,
                          modelValue: _ctx.partOfCompanyTrue,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.partOfCompanyTrue) = $event)),
                          "hide-details": "",
                          class: "my-0",
                          label: "Fait partie de la société",
                          ripple: false,
                          readonly: ""
                        }, null, 8, ["modelValue"]))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.companyUser)
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 7,
          "no-gutters": "",
          class: "mt-2"
        }, {
          default: _withCtx(() => [
            (!_ctx.isLegalPerson)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 0,
                  cols: "4",
                  class: "pl-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select_filled, {
                      outlined: "",
                      items: _ctx.legalRepresentativeTypes,
                      modelValue: _ctx.companyUser.legalRepresentativeType,
                      "onUpdate:modelValue": [
                        _cache[4] || (_cache[4] = ($event: any) => ((_ctx.companyUser.legalRepresentativeType) = $event)),
                        _cache[5] || (_cache[5] = ($event: any) => (_ctx.onLegalRepresentativeTypeChanged()))
                      ],
                      label: "Qualité",
                      disabled: _ctx.currentUserIsAccountingEmployee,
                      "hide-details": "",
                      density: "compact",
                      "item-title": "text"
                    }, null, 8, ["items", "modelValue", "disabled"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_v_col, {
              cols: "4",
              class: "d-flex align-center pl-5"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_switch, {
                  modelValue: _ctx.companyUser.accountingLegalRepresentative,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.companyUser.accountingLegalRepresentative) = $event)),
                  "hide-details": "",
                  class: "my-0",
                  label: _ctx.switchLabel,
                  ripple: false,
                  disabled: _ctx.companyUser.legalRepresentativeType == null,
                  readonly: _ctx.companyUser.legalRepresentativeType == null
                }, null, 8, ["modelValue", "label", "disabled", "readonly"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.companyUser && _ctx.isAccountActive)
      ? (_openBlock(), _createBlock(_component_v_divider, {
          key: 8,
          class: "my-2"
        }))
      : _createCommentVNode("", true),
    (_ctx.isAccountActive)
      ? (_openBlock(), _createBlock(_component_ProfileManagement, {
          key: 9,
          companyId: _ctx.company.id,
          user: _ctx.user,
          companyUser: _ctx.companyUser,
          inComponent: true,
          onUpdatedCompanyUser: _cache[7] || (_cache[7] = ($event: any) => (_ctx.updateCompanyUser($event)))
        }, null, 8, ["companyId", "user", "companyUser"]))
      : _createCommentVNode("", true)
  ]))
}